export var maskEmail = function (email) {
    var middle = email.substring(1, email.indexOf('@') - 1);
    return email.replace(middle, '*****');
};
